<template>
  <button
    class="mdn-Menu-top-event mdn-Menu-top-contrast-action"
    title="Opção de acessibilidade. Clique para alterar o contraste do Portal"
    @click.prevent="setContrast()"
  >
    <span
      class="mdn-Icon-alto-contraste mdn-Icon--sm"
      aria-hidden="true"
    ></span>
  </button>
</template>
<script lang="ts">
import Vue from "vue";

import { Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";

@Component({
  name: "ContrastButton",
})
export default class ContrastButton extends Vue {
  @Action setTheme!: ActionMethod;

  contrast = false;

  setContrast(): void {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:link",
        eventLabel: "acessibilidade:modo-de-visualizacao",
      });
    }

    if (this.contrast) {
      this.contrast = false;
      win.MondrianVanilla.setTheme("normal");
      this.setTheme("normal");
    } else {
      this.contrast = true;
      win.MondrianVanilla.setTheme("contrast");
      this.setTheme("contrast");
    }
  }
}
</script>

<style lang="scss" scoped></style>
